import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FieldWrapperComponent} from './field-wrapper/field-wrapper.component';
import {GenericFieldComponent} from './fields/generic-field/generic-field.component';
import {TextFieldComponent} from './fields/text-field/text-field.component';
import {FormsModule} from '@angular/forms';
import {NumberFieldComponent} from './fields/number-field/number-field.component';
import {DateFieldComponent} from './fields/date-field/date-field.component';
import {CalendarModule} from 'primeng/calendar';
import {MultiColumnFieldComponent} from './fields/multi-column-field/multi-column-field.component';
import {TimeFieldComponent} from './fields/time-field/time-field.component';
import {DropdownFieldComponent} from './fields/dropdown-field/dropdown-field.component';
import {DropdownModule} from 'primeng/dropdown';
import {CustomerFieldComponent} from './fields/customer-field/customer-field.component';
import {WorkerFieldComponent} from './fields/worker-field/worker-field.component';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {BooleanFieldComponent} from './fields/boolean-field/boolean-field.component';
import {InputSwitchModule} from 'primeng/inputswitch';
import {TextareaFieldComponent} from './fields/textarea-field/textarea-field.component';
import {FieldLabelComponent} from './field-label/field-label.component';
import {ActionItemsComponent} from './action-items/action-items.component';
import {SingleSelectComponent} from './fields/single-select/single-select.component';
import {MultiSelectComponent} from './fields/multi-select/multi-select.component';
import {FlagMultiSelectComponent} from './fields/flag-multi-select/flag-multi-select.component';
import {FlagSingleSelectComponent} from './fields/flag-single-select/flag-single-select.component';
import {MultiColumnSeparatorComponent} from './fields/multi-column-separator/multi-column-separator.component';
import {CarrierSingleSelectComponent} from './fields/carrier-single-select/carrier-single-select.component';
import {ButtonComponent} from './button/button.component';
import {FlexRowComponent} from './flex-row/flex-row.component';
import {FlexSeparatorComponent} from './flex-separator/flex-separator.component';
import {LabelComponent} from './label/label.component';
import {QuickFlagWidgetComponent} from './quick-flag-widget/quick-flag-widget.component';
import {FlagModule} from '../flag/flag.module';
import {SquareButtonComponent} from './square-button/square-button.component';
import {ImageHandlerComponent} from './image-handler/image-handler.component';
import {JobFieldComponent} from './fields/job-field/job-field.component';
import {PostFieldComponent} from './fields/post-field/post-field.component';
import {DateFieldIntervalComponent} from './date-field-interval/date-field-interval.component';
import {ToastModule} from 'primeng/toast';
import {SmallLabelComponent} from './small-label/small-label.component';
import {FlexDashSeparatorComponent} from './flex-dash-separator/flex-dash-separator.component';
import {CarrierRedirectComponent} from './carrier-redirect/carrier-redirect.component';
import {UserLabelComponent} from './user-label/user-label.component';
import {AvatarModule} from 'primeng/avatar';
import {TooltipModule} from 'primeng/tooltip';
import {PlatformAwareComponent} from './platform-aware/platform-aware.component';
import {InputTextModule} from 'primeng/inputtext';
import {LearningPortalComponent} from './learning-portal/learning-portal.component';
import {AppointmentNotificationComponent} from './appointment-notification/appointment-notification.component';
import {
  AppointmentNotificationsHolderComponent
} from './appointment-notifications-holder/appointment-notifications-holder.component';
import {SingleDropdownComponent} from "./fields/single-dropdown/single-dropdown.component";
import {MultiDropdownComponent} from "./fields/multi-dropdown/multi-dropdown.component";
import {MultiSelectModule} from "primeng/multiselect";
import { SnippetFieldComponent } from './fields/snippet-field/snippet-field.component';

@NgModule({
  declarations: [
    FieldWrapperComponent,
    GenericFieldComponent,
    TextFieldComponent,
    NumberFieldComponent,
    DateFieldComponent,
    MultiColumnFieldComponent,
    TimeFieldComponent,
    DropdownFieldComponent,
    CustomerFieldComponent,
    WorkerFieldComponent,
    BooleanFieldComponent,
    TextareaFieldComponent,
    FieldLabelComponent,
    ActionItemsComponent,
    SingleSelectComponent,
    MultiSelectComponent,
    FlagMultiSelectComponent,
    FlagSingleSelectComponent,
    MultiColumnSeparatorComponent,
    CarrierSingleSelectComponent,
    ButtonComponent,
    FlexRowComponent,
    FlexSeparatorComponent,
    LabelComponent,
    QuickFlagWidgetComponent,
    SquareButtonComponent,
    ImageHandlerComponent,
    JobFieldComponent,
    PostFieldComponent,
    DateFieldIntervalComponent,
    SmallLabelComponent,
    FlexDashSeparatorComponent,
    AppointmentNotificationsHolderComponent,
    CarrierRedirectComponent,
    UserLabelComponent,
    PlatformAwareComponent,
    LearningPortalComponent,
    AppointmentNotificationComponent,
    SingleDropdownComponent,
    MultiDropdownComponent,
    SnippetFieldComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    CalendarModule,
    DropdownModule,
    AutoCompleteModule,
    InputSwitchModule,
    FlagModule,
    ToastModule,
    AvatarModule,
    TooltipModule,
    InputTextModule,
    MultiSelectModule,
  ],
  exports: [
    FieldWrapperComponent,
    TextFieldComponent,
    NumberFieldComponent,
    DateFieldComponent,
    MultiColumnFieldComponent,
    TimeFieldComponent,
    DropdownFieldComponent,
    CustomerFieldComponent,
    WorkerFieldComponent,
    BooleanFieldComponent,
    TextareaFieldComponent,
    FieldLabelComponent,
    ActionItemsComponent,
    SingleSelectComponent,
    MultiSelectComponent,
    FlagMultiSelectComponent,
    FlagSingleSelectComponent,
    MultiColumnSeparatorComponent,
    CarrierSingleSelectComponent,
    ButtonComponent,
    FlexRowComponent,
    FlexSeparatorComponent,
    LabelComponent,
    QuickFlagWidgetComponent,
    SquareButtonComponent,
    ImageHandlerComponent,
    JobFieldComponent,
    PostFieldComponent,
    DateFieldIntervalComponent,
    SmallLabelComponent,
    FlexDashSeparatorComponent,
    AppointmentNotificationsHolderComponent,
    CarrierRedirectComponent,
    UserLabelComponent,
    LearningPortalComponent,
    GenericFieldComponent,
    SingleDropdownComponent,
    MultiDropdownComponent,
    SnippetFieldComponent,
  ]
})
export class WidgetLibraryModule { }
